import React, { Fragment } from 'react';

import { Button, Switch } from '@mui/material';
import {
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarQuickFilter
} from '@mui/x-data-grid';

import styles from 'pages/TimeseriesPage/TimeseriesPage.module.scss';

interface TimeseriesCustomToolbarProps {
  tableTitle: string;
  button?: {
    disabled: boolean;
    label: string;
    onClick: () => void;
  },
  switch?: {
    isChecked: boolean;
    label: string;
    onToggle: () => void;
  }
}

export const TimeseriesCustomToolbar = (props: TimeseriesCustomToolbarProps) => {
  return (
    <Fragment>
      <div className={styles.tableTitleBar}>
        <div className={styles.tableTitle}>{props.tableTitle}</div>
        <div className={styles.tableTitleBarButtonWrapper}>
          { props.button && (
              <Button
                className={styles.tableTitleBarButton}
                onClick={props.button.onClick}
                variant={'contained'}
                disabled={props.button.disabled}
              >
                {props.button.label}
              </Button>
            )
          }
        </div>
      </div>

      <GridToolbarContainer>
        <GridToolbarQuickFilter />
        <GridToolbarDensitySelector />
        { props.switch && (
          <div className={styles.toolbarSwitch}>
            {props.switch.label}
            <Switch
              checked={props.switch.isChecked}
              onChange={props.switch.onToggle}
            ></Switch>
          </div>
        )}
      </GridToolbarContainer>
    </Fragment>
  );
}
